<template>
  <div class="main">
    <div class="col-gauche">
      <img src="../assets/overlayLogin.png" alt="image emotion culturel" />
    </div>
    <div class="col-droite">
      <form @submit="onSubmit">
        <div class="information">
          <p>
            Entrez le nouveau mot de passe, confirmez le nouveau mot de passe,
            puis cliquez sur le bouton SAUVEGARDER
          </p>
        </div>
        <div class="field">
          <div class="passwordCtn">
            <label for="password_verif">Nouveau mot de passe</label>
            <input
              class="password"
              v-model="form.password"
              :type="passwordSecret"
              name="password"
              id="password_verif"
              placeholder="Nouveau mot de passe"
              required
            />
            <img
              v-if="passwordSecret == 'password'"
              src="../assets/invisible.png"
              class="togglePassword"
              id="password_toggle"
              @click="switchPasswordSecret('visible')"
            />
            <img
              v-if="passwordSecret == 'text'"
              src="../assets/visible.png"
              class="togglePassword"
              id="password_toggle"
              @click="switchPasswordSecret('invisible')"
            />
          </div>
        </div>
        <div class="field">
          <div class="passwordCtn">
            <label for="password_verif"
              >Confirmation de votre mot de passe</label
            >
            <input
              class="password"
              :type="passwordSecret"
              v-model="form.confirmPassword"
              name="password"
              id="password_verif"
              placeholder="Confirmation de votre mot de passe"
              required
            />
            <img
              v-if="passwordSecret == 'password'"
              src="../assets/invisible.png"
              class="togglePassword"
              id="password_toggle"
              @click="switchPasswordSecret('visible')"
            />
            <img
              v-if="passwordSecret == 'text'"
              src="../assets/visible.png"
              class="togglePassword"
              id="password_toggle"
              @click="switchPasswordSecret('invisible')"
            />
          </div>
        </div>
        <input
          class="btn-submit"
          type="submit"
          value="Sauvegarder et se connecter"
        />
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      passwordSecret: "password",
      form: {},
    };
  },
  methods: {
    switchPasswordSecret(state) {
      if (state == "visible") {
        this.passwordSecret = "text";
      }
      if (state == "invisible") {
        this.passwordSecret = "password";
      }
    },
    ...mapActions(["resetPassword"]),
    onSubmit(event) {
      event.preventDefault();
      if (this.form.confirmPassword === this.form.password) {
        this.resetPassword({
          token: this.form.token,
          password: this.form.password,
        });
        /* this.$router.push({
        name: "Signin",
      });*/
      }
    },
  },
  created() {
    this.form.token = this.$route.query.token;
  },
};
</script>

<style scoped src="../assets/styleLogin.css"></style>
